import { env } from '../../../environments/environment';

export const APIURL = `${env.url}/api/v1`;
export const HUBURL = `${env.url}/hub`;
